export default __webpack_public_path__ + "static/media/hot-auction.4c6c5cb4.jpeg";